import { useEffect, useRef, useState } from "react";

import GuestImg from "../../assets/images/conversations/ep-19-cyrus-dhabhar-guest.webp";
import ThumbImg from "../../assets/images/conversations/019.webp";
import PlayIcon  from "../../assets/icons/conversations/play-icon.svg";

/* ─────────────────────────────────────────────
   PREFIX: cd2-
───────────────────────────────────────────── */
const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700;800&family=Roboto:wght@400;500&display=swap');

  *, *::before, *::after { margin: 0; padding: 0; box-sizing: border-box; }

  .cd2-page {
    background: #1A1A1A;
    min-height: 100vh;
    font-family: 'Roboto', sans-serif;
    color: #fff;
  }
  .cd2-inner {
    max-width: 1600px;
    margin: 0 auto;
    padding-left: 102px;
    padding-right: 102px;
  }

  /* ── HERO ── */
  .cd2-hero { padding-top: 60px; padding-bottom: 60px; }
  .cd2-hero__grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 30px;
    align-items: start;
  }
  .cd2-hero__left { display: flex; flex-direction: column; gap: 44px; }
  .cd2-hero__title {
    font-family: 'Montserrat', sans-serif;
    font-size: 32px;
    font-weight: 700;
    color: #ffffff;
    line-height: 140%;
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .cd2-hero__title.cd2-visible { opacity: 1; transform: translateY(0); }
  .cd2-hero__spotify {
    border-radius: 12px;
    overflow: hidden;
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease 0.18s, transform 0.7s ease 0.18s;
  }
  .cd2-hero__spotify.cd2-visible { opacity: 1; transform: translateY(0); }
  .cd2-hero__spotify iframe {
    display: block; width: 100%; height: 152px; border: none; border-radius: 12px;
  }
  .cd2-hero__right {
    opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease 0.1s, transform 0.7s ease 0.1s;
  }
  .cd2-hero__right.cd2-visible { opacity: 1; transform: translateY(0); }

  /* ── YOUTUBE THUMB ── */
  .cd2-yt-thumb {
    position: relative; width: 100%; border-radius: 12px;
    overflow: hidden; cursor: pointer; display: block; background: #000;
  }
  .cd2-yt-thumb img {
    width: 100%; height: auto; display: block;
    border-radius: 12px; transition: opacity 0.3s ease;
  }
  .cd2-yt-thumb:hover img { opacity: 0.85; }
  .cd2-yt-thumb__play {
    position: absolute; top: 50%; left: 50%;
    transform: translate(-50%, -50%);
    background: none; border-radius: 50%;
    display: flex; align-items: center; justify-content: center;
    pointer-events: none;
  }
  .cd2-yt-thumb__play img { width: 40px; height: 44px; }
  .cd2-yt-iframe-wrap {
    position: relative; width: 100%; padding-bottom: 56.25%;
    height: 0; border-radius: 12px; overflow: hidden;
  }
  .cd2-yt-iframe-wrap iframe {
    position: absolute; top: 0; left: 0;
    width: 100%; height: 100%; border: none;
  }

  /* ── BODY ── */
  .cd2-body {
    padding-bottom: 100px; opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .cd2-body.cd2-visible { opacity: 1; transform: translateY(0); }
  .cd2-body__para {
    font-family: 'Roboto', sans-serif; font-size: 16px;
    font-weight: 400; color: #E2E2E2; line-height: 160%; margin-bottom: 14px;
  }
  .cd2-body__para:last-child { margin-bottom: 0; }

  /* ── GUEST ── */
  .cd2-guest {
    padding-bottom: 100px; text-align: center; opacity: 0;
    transform: translateY(40px);
    transition: opacity 0.7s ease, transform 0.7s ease;
  }
  .cd2-guest.cd2-visible { opacity: 1; transform: translateY(0); }
  .cd2-guest__title {
    font-family: 'Montserrat', sans-serif; font-size: 50px;
    font-weight: 700; color: #ffffff; margin-bottom: 60px;
  }
  .cd2-guest__photo-bg {
    display: inline-block; width: 445px; height: 500px;
    background: #743FAC; border-radius: 12px; overflow: hidden;
  }
  .cd2-guest__photo-bg img {
    width: 100%; height: 100%; object-fit: cover;
    object-position: top center; display: block;
  }
  .cd2-guest__name {
    font-family: 'Montserrat', sans-serif; font-size: 32px;
    font-weight: 700; color: #ffffff; margin-top: 24px;
  }

  /* ── TABLET (max 768px) ── */
  @media (max-width: 768px) {
    .cd2-inner { padding-left: 32px; padding-right: 32px; }
    .cd2-hero { padding-top: 32px; padding-bottom: 48px; }
    .cd2-hero__grid { grid-template-columns: 1fr 1fr; gap: 24px; }
    .cd2-hero__title { font-size: 24px; }
    .cd2-hero__left { gap: 16px; }
    .cd2-guest__title { font-size: 24px; margin-bottom: 24px; }
    .cd2-guest__photo-bg { width: 260px; height: 300px; }
    .cd2-guest__name { font-size: 24px; margin-top: 18px; }
    .cd2-body__para { font-size: 14px; margin-bottom: 12px; }
    .cd2-body { padding-bottom: 48px; }
    .cd2-guest { padding-bottom: 48px; }
    .cd2-yt-thumb__play img { width: 30px; height: 32px; }
  }

  /* ── MOBILE (max 480px) ── */
  @media (max-width: 480px) {
    .cd2-inner { padding-left: 16px; padding-right: 16px; }
    .cd2-hero { padding-top: 51px; padding-bottom: 30px; }
    .cd2-hero__grid { grid-template-columns: 1fr; gap: 30px; }
    .cd2-hero__left { gap: 30px; }
    .cd2-hero__title { font-size: 30px; }
    .cd2-body__para { font-size: 16px; margin-bottom: 10px; }
    .cd2-guest__title { font-size: 30px; margin-bottom: 20px; text-align: left; }
    .cd2-guest__photo-bg { width: 100%; height: 386px; }
    .cd2-guest__name { font-size: 24px; text-align: left; margin-top: 14px; }
    .cd2-body { padding-bottom: 30px; }
    .cd2-guest { padding-bottom: 30px; }
    .cd2-yt-thumb__play img { width: 30px; height: 32px; }
  }
`;

function useFadeUp(ref) {
  useEffect(() => {
    if (!ref.current) return;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("cd2-visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12 }
    );
    observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);
}

const YT_VIDEO_ID = "2zBX2txwlIY";

function YouTubeEmbed() {
  const [playing, setPlaying] = useState(false);
  if (playing) {
    return (
      <div className="cd2-yt-iframe-wrap">
        <iframe
          src={`https://www.youtube.com/embed/${YT_VIDEO_ID}?autoplay=1&rel=0`}
          title="EP 19 Cyrus Dhabhar Powerdrift"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      </div>
    );
  }
  return (
    <div
      className="cd2-yt-thumb"
      onClick={() => setPlaying(true)}
      role="button"
      aria-label="Play video"
    >
      <img src={ThumbImg} alt="EP 19 Cyrus Dhabhar thumbnail" />
      <div className="cd2-yt-thumb__play">
        <img src={PlayIcon} alt="Play" />
      </div>
    </div>
  );
}

function HeroSection() {
  const titleRef   = useRef(null);
  const spotifyRef = useRef(null);
  const rightRef   = useRef(null);
  useFadeUp(titleRef);
  useFadeUp(spotifyRef);
  useFadeUp(rightRef);

  return (
    <section className="cd2-hero">
      <div className="cd2-inner">
        <div className="cd2-hero__grid">
          <div className="cd2-hero__left">
            <h1 ref={titleRef} className="cd2-hero__title">
              EP 19 | What are EV Manufacturers doing wrong? | Cyrus Dhabar | Powerdrift
            </h1>
            <div ref={spotifyRef} className="cd2-hero__spotify">
              <iframe
                src="https://open.spotify.com/embed/episode/5JL2l2CBYzt0ETJaUt9DdF?utm_source=generator&theme=0"
                allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
                loading="lazy"
                title="EP 19 Spotify Player"
              />
            </div>
          </div>
          <div ref={rightRef} className="cd2-hero__right">
            <YouTubeEmbed />
          </div>
        </div>
      </div>
    </section>
  );
}

function BodySection() {
  const ref = useRef(null);
  useFadeUp(ref);
  return (
    <section ref={ref} className="cd2-body">
      <div className="cd2-inner">
        <p className="cd2-body__para">
          During the recent annual budget presented by the finance minister in February 2022, she made firm policy announcements on battery swapping infrastructure and it's evident that policy objectives are clearly towards massive swift to clean mobility by 2030. We already have determined that the present buying cycle for ICE vehicles is likely the last one where EVs marks the logical procurement choice and that when the vehicles bought this year come up for a replacement in 3 or 5 years; the natural buying decision will likely be an EV rather than an ICE vehicle unless the EV industry itself messes up the golden opportunity presented to it.
        </p>
        <p className="cd2-body__para">
          As of February 2022, India has a few million electric Rickshaws of varying battery technologies including lead-acid and lithium-ion chemistries. There are some 300 thousand electric scooters, a few thousand electric buses, but less than 20,000 personal electric cars. The passenger car segment, in particular, has a low level of penetration in India with only a few OEMs offering electric vehicles. New launches planned in 2022 this year includes at the top-end the Mini Cooper Electric, the Volvo XC40 Electric and the Mercedes-Benz EQA. At the other end of the spectrum, TATA, and MG plan to launch new electric vehicles models in the 10 to 15 lakhs price spectrum, yet the choice for electric cars continues to be very limited and the disconnect is looming. So, what's the go? What is the industry doing wrong? What is hampering OEMs from keeping up with the hype that they themselves have created?
        </p>
        <p className="cd2-body__para">
          To help examine this subject, today we speak with Cyrus Dhabar, Head of Content of Powerdrift; India's biggest automotive media house.
        </p>
      </div>
    </section>
  );
}

function GuestSection() {
  const ref = useRef(null);
  useFadeUp(ref);
  return (
    <section ref={ref} className="cd2-guest">
      <div className="cd2-inner">
        <h2 className="cd2-guest__title">Our Guest</h2>
        <div>
          <div className="cd2-guest__photo-bg">
            <img src={GuestImg} alt="Cyrus Dhabhar" />
          </div>
          <p className="cd2-guest__name">Cyrus DHABHAR</p>
        </div>
      </div>
    </section>
  );
}

export default function Ep19CyrusDhabhar() {
  return (
    <>
      <style>{CSS}</style>
      <div className="cd2-page">
        <HeroSection />
        <BodySection />
        <GuestSection />
      </div>
    </>
  );
}